<template>
  <div>
    <div class="font16 marginbottom20 pointer numberHeaderContainer darkblue"
         v-if="dinings.options.length !== 0"
         style="line-height: 18px; margin-right: 12px; display: flex; flex-flow: column;">
      <div  class="numberHeaderSubtitle darkblue"><b>Kies je dinerzitting</b></div>
    </div>

    <div class="show"
      v-if="dinings.options.length !== 0"
      >
      <div class="midblock width100">
        <table
            cellspacing="0px"
            cellpadding="10px"
            width="100%"
            class="hoverme"
        >
          <tr
              valign="middle"
              v-for="dining in dinings.options"
              v-on:click="selectDining(dining)"
              class="pointer"
              :class="{
                          selectedRow: dinings.selected === dining.Sitting
                      }"
          >
            <td
                align="center"
                style="border-top: 1px solid rgb(221, 221, 221);"
            >
              <input
                  type="radio"
                  :checked="dinings.selected === dining.Sitting"
              />
            </td>
            <td
                style="border-top: 1px solid rgb(221, 221, 221);"
            >
              <div
                  v-if="dining.Sitting === 'O'"
              >
                <strong>Open zitting</strong><br>
                Bij een open zitting heb je de ruimte en vrijheid om zelf te bepalen hoelaat je iedere avond binnen de openingstijden van het restaurant wilt dineren in het hoofdrestaurant! Er wordt geen vaste tafel gereserveerd en je hebt ook geen vaste ober. Het kan zijn dat je even moet wachten op de eerst volgende beschikbare tafel. <strong>Let op dat de fooien vooraf betaald dienen te worden.</strong>
              </div>
              <div
                  v-else-if="dining.Sitting === 'M'"
              >
                <strong>Vroege zitting</strong><br>
                Met de vroege dinerzitting heb je een tafel gereserveerd in het inbegrepen hoofdrestaurant! Vaak dien je aanwezig te zijn op een vast tijdstip meestal tussen 17:30 uur en 18:00 uur, afhankelijk van het vaargebied. De verplichte fooien zijn aan boord of optioneel vooraf te betalen
              </div>
              <div
                  v-else-if="dining.Sitting === '2'"
              >
                <strong>Late zitting</strong><br>
                Met de late dinerzitting heb je een tafel gereserveerd in het inbegrepen hoofdrestaurant! Vaak dien je aanwezig te zijn op een vast tijdstip meestal tussen 19:30 uur en 20:00 uur, afhankelijk van het vaargebied. De verplichte fooien zijn aan boord of optioneel vooraf te betalen
              </div>
            </td>
            <td valign="middle"
                :class="{ dim: true }"
                style="border-top: 1px solid rgb(221, 221, 221);"
            >
              <div v-if="dinings.selected === dining.Sitting" style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
              <button v-else
                      class="btn btn-success btn-addon width100 font14 bold"

              >
                Selecteer <font-awesome-icon icon="angle-right" />
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="font16 marginbottom20 pointer numberHeaderContainer darkblue"
         v-if="dinings.fees !== 0"
         style="line-height: 18px; margin-right: 12px; display: flex; flex-flow: column; width: 100%; padding-top: 20px;">
      <div  class="numberHeaderSubtitle darkblue"><b>Fooien bijboeken</b></div>
    </div>

    <div class="show"
         v-if="dinings.fees !== 0"
      >
      <div class="midblock width100">
        <table
            cellspacing="0px"
            cellpadding="10px"
            width="100%"
            class="hoverme"
        >
          <tr
              valign="middle"
              v-on:click="selectEarlyFees(false)"
              class="pointer"
              :class="{
                          selectedRow: !dinings.feesSelected,
                          disabled:  dinings.selected === 'O'
                      }"
          >
            <td
                align="center"
                style="border-top: 1px solid rgb(221, 221, 221);"
            >
              <input
                  type="radio"
                  :checked="!dinings.feesSelected"
              />
            </td>
            <td style="border-top: 1px solid rgb(221, 221, 221);">
              <strong>Fooien niet bijboeken</strong>
            </td>
            <td valign="middle"
                :class="{ dim: true }"
                style="border-top: 1px solid rgb(221, 221, 221);">
              <div v-if="!dinings.feesSelected" style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
              <button v-else
                      class="btn btn-success btn-addon width100 font14 bold">
                Selecteer <font-awesome-icon icon="angle-right" />
              </button>
            </td>
          </tr>
          <tr
              valign="middle"
              v-on:click="selectEarlyFees(true)"
              class="pointer"
              :class="{
                          selectedRow: dinings.feesSelected
                      }">
            <td
                align="center"
                style="border-top: 1px solid rgb(221, 221, 221);">
              <input
                  type="radio"
                  :checked="dinings.feesSelected"
              />
            </td>
            <td
                style="border-top: 1px solid rgb(221, 221, 221);"
            >
              <strong>Fooien Bijboeken</strong> (v.a. € {{ dinings.fees }})
            </td>
            <td valign="middle"
                :class="{ dim: true }"
                style="border-top: 1px solid rgb(221, 221, 221);">
              <div v-if="dinings.feesSelected" style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
              <button v-else
                      class="btn btn-success btn-addon width100 font14 bold">
                Selecteer <font-awesome-icon icon="angle-right" />
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DinerSettings',
  props: {
    dinings: Object,
    diningsRecieved: Boolean,
  },
  methods: {
    selectDining: function(dining) {
      if(dining.Sitting === 'O') {
        this.dinings.feesSelected = true;
      }
      this.dinings.selected = dining.Sitting;
    },
    selectEarlyFees: function(earlyFees) {
      this.dinings.feesSelected = earlyFees;
    },
  },
}
</script>
<style scoped>
.selectedRow{
  background: #f3f9fd;
}
</style>